import axios from 'axios';
import store from "@/store";
import router from "@/router";
import { BModal } from 'bootstrap-vue'
import { Toast } from 'bootstrap-vue'
const service = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 50000
});

service.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers['Authorization'] = store.state.token // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config;
    },
    error => {
        // eslint-disable-next-line no-console
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            const res = response.data
            if (response.config.responseType === 'blob') {
                return res
            }
            if (res.code !== 200) {
                if (res.code === 401) {
                    store.dispatch('logout')
                    router.push({path: '/login'})
                }
                console.log(res, 123123)
                return Promise.reject(res)
            } else {
                return res
            }
        } else {
            Promise.reject();
        }
    },
    error => {
        // eslint-disable-next-line no-console
        console.log(error);
        return Promise.reject();
    }
);

export default service;
